import InvoiceDetail from './InvoiceDetail';
import InvoiceDoc from './InvoiceDoc';

export default class Invoice {
    clientType?: number | null;
    bopRate?: number | null;
    bopAssignee?: number | null;
    number?: string | null = null;
    beginDate?: Date | null = null;
    endDate?: Date | null = null;
    clientNumber?: string | null = null;
    projectNumber?: string | null = null;
    projectId?: number | null = null;
    subCode?: string | null = null;
    accountNumber?: number | null = null;
    factor?: number | null = null;
    formatType?: string | null = null;
    prdType?: string | null = null;
    invoiceDate?: Date | null = null;
    total?: number | null = null;
    process?: string | null = null;
    voidReason?: string | null = null;
    voidedBy?: string | null = null;
    voidDate?: Date | null = null;
    groupClosed?: boolean | null = null;
    voided?: boolean | null = null;
    source?: string | null = null;
    checkNumber?: string | null = null;
    checkDate?: Date | null = null;
    amountPaid?: number | null = null;
    postToAR?: boolean | null = null;
    altSubcode?: string | null = null;
    unitId?: number | null = null;
    postVoid?: boolean | null = null;
    timesheetDoc?: boolean | null = null;
    postToArOpenIg?: boolean | null = null;
    office?: string | null = null;
    createdByNumber?: string | null = null;
    createdByName?: string | null = null;
    creationTime?: Date | null = null;
    updatedByNumber?: string | null = null;
    updatedByName?: string | null = null;
    updatedTime?: Date | null = null;
    postedByNumber?: string | null = null;
    postedByName?: string | null = null;
    postedTime?: Date | null = null;
    pvByNumber?: string | null = null;
    pvByName?: string | null = null;
    pvTime?: Date | null = null;
    invoiceIrNumber?: string | null = null;
    selection?: boolean | null;
    documents?: Array<InvoiceDoc> | null;
    details?: Array<InvoiceDetail> | null;
    header?: string | null = null;
  }  


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceMaster.ts